export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}user/assignment/:id`;
    const companyPrivilegesUrl = `${SEED_CORE.ENV.API_URL}user/user/:id/set-company-privileges`;

    return $resource(url, null, {
        setCompanyPrivileges: {
            method: 'POST',
            url: companyPrivilegesUrl
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/UserAssignment/index.js